import {
    FunctionComponent,
    useState,
    useRef,
    useMemo,
    useCallback,
} from 'react';
import {
    Button,
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody,
    AlertDialogFooter,
    Center,
    Badge,
} from '@chakra-ui/react';

import { PinInput, PinInputField } from '@chakra-ui/react';

type ClearDataDialogProps = {
    colorScheme: string;
    onConfirm: () => void;
    onDiscard: () => void;
};

function generateRandomPin(length: number) {
    return Array.from({ length: length })
        .map(() => Math.floor(Math.random() * 9))
        .join('');
}

const ClearDataDialog: FunctionComponent<ClearDataDialogProps> = ({
    colorScheme,
    children,
    onConfirm,
    onDiscard,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const onClose = () => setIsOpen(false);
    const cancelRef = useRef(null);
    const [pinOk, setPinOk] = useState(false);

    const randomPin: string = useMemo(() => generateRandomPin(4), []);

    const handlePinChange = useCallback(pin => setPinOk(pin === randomPin), [
        pinOk,
    ]);

    const handleConfirm = useCallback(() => {
        onConfirm && onConfirm();
        onClose();
    }, []);

    return (
        <>
            <Button colorScheme={colorScheme} onClick={() => setIsOpen(true)}>
                {children}
            </Button>

            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            Attenzione! Cancellazione dati Wallet
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Center>
                                Sei sicuro di voler cancellare i dati del tuo
                                Wallet? Se non hai effettuato un backup, non
                                potrai più avere accesso al tuo wallet.
                            </Center>
                            <Center>
                                Se sei sicuro, inserisci il seguente codice e
                                premi sul tasto 'Cancella i dati'
                            </Center>
                            <Center>
                                {randomPin.split('').map((char, i) => (
                                    <Badge m={3} p={1} key={i}>
                                        {char}
                                    </Badge>
                                ))}
                            </Center>
                            <Center>
                                <PinInput
                                    type='number'
                                    onChange={handlePinChange}
                                    autoFocus
                                >
                                    <PinInputField />
                                    <PinInputField />
                                    <PinInputField />
                                    <PinInputField />
                                </PinInput>
                            </Center>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Annulla
                            </Button>
                            <Button
                                colorScheme='red'
                                onClick={handleConfirm}
                                ml={3}
                                disabled={!pinOk}
                            >
                                Cancella i dati
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    );
};

export default ClearDataDialog;
